import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';

import SlickBar from 'components/SlickBar';
import VideoThumbnail from '../elements/VideoThumbnail';
import VideoModal from 'components/VideoModal';
import IEKTalks from '../elements/IEKTalks';

import vw from 'styles/utils';
import media from 'styles/media';

import hero from 'data/hero';
import videosData from 'data/video';

function VideoBar() {
  const [isShowModal, setIsShowModal] = useState(false);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
  const [imagesIndex, setImagesIndex] = useState([]);

  useEffect(() => {
    let tmpImagesIndex = [];
    let indexPool = Array.from(Array(16).keys()); // [0, 1, 2 ... 14, 15]

    for(let i=0; i<14; i++) {
      let index = Math.floor((Math.random() * indexPool.length));
      tmpImagesIndex.push(indexPool[index]);
      indexPool.splice(index, 1);
      // console.log(index, tmpImagesIndex)
    }
    
    setImagesIndex(tmpImagesIndex)
    // console.log(tmpImagesIndex)
  }, [])

  const handleClickCloseButton = () => {
    // setSelectedVideoIndex(0);
    setIsShowModal(false);
  }

  const handleShowModal = (index) => {
    setSelectedVideoIndex(index);
    setIsShowModal(true);
  }

  const handleClickPrevButton = () => {
    if (selectedVideoIndex === 0) {
      setSelectedVideoIndex(videosData.length - 1);
    } else {
      setSelectedVideoIndex(selectedVideoIndex - 1);
    }
  }

  const handleClickNextButton = () => {
    if (selectedVideoIndex === videosData.length - 1) {
      setSelectedVideoIndex(0);
    } else {
      setSelectedVideoIndex(selectedVideoIndex + 1);
    }
  }

  return (
    <Root>
      <Row>
        <AICol>
          <SlickBar
            icon={require('assets/images/icons/net-zero.png')}
            title="AI 微學習"
            slidesToShow={3}
            slidesToScroll={3}
          >
            {
              videosData.map((video, index) => (
                <VideoThumbnail
                  src={hero[imagesIndex[index]]}
                  title={video.title}
                  onClick={() => handleShowModal(index)}
                  key={`video ${index}`}
                />
              ))
            }
          </SlickBar>
        </AICol>
        <IEKTalkCol>
          <IEKTalks />
        </IEKTalkCol>
      </Row>
      <VideoModal
        show={isShowModal}
        selectedVideoIndex={selectedVideoIndex}
        onClickPrevButton={handleClickPrevButton}
        onClickNextButton={handleClickNextButton}
        onClickCloseButton={handleClickCloseButton}
      />
    </Root>
  )
}

const Root = styled.section`
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;

  @media ${media.desktop} {
    flex-direction: row;
  }
`;

const AICol = styled.div`
  width: 100%;
  
  @media ${media.desktop} {
    width: 75%;
  }
`;

const IEKTalkCol = styled.div`
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;

  @media ${media.desktop} {
    width: 75%;
  }

  ${vw('height', 180, 180, 200)}
  ${vw('margin-top', 20, 20, 60)}
  ${vw('margin-left', 0, 0, 10)}
`;


export default VideoBar
